<script lang="ts">
  let className = '';
  export {className as class};
  export let text = ''
</script>
<style lang="scss">
  .split{
    padding: 20px 0;
    height: 16px;
    .line{
      width: 100%;
      height: 1px;
      background: #DBDFE7;
    }
    .pa{
      top: 20px;
      left: 50%;
      transform: translate(-50%, 0);
      text-transform: capitalize;
    }
  }
  .c-grey{
    color: #6C6E74;
  }
</style>

<div class="split pr df aic {className}">
  <div class="line"/>
  <div class="pa tc B2 ph12 c-grey f12 lh16 fw1">{text}</div>
</div>
